import Paper from "@mui/material/Paper";
import React, { Component } from "react";
import { getShiftDate, getShiftTime } from "../util/dateTimeFormatter.js";
import TradeDialog from "./TradeDialog.jsx";
import PropTypes from "prop-types";
export class EmployeeTradeMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDialogOpen: false,
      isDialogTriggered: false,
    };
  }

  handleClickDialogOpen() {
    this.setState({
      isDialogOpen: true,
      isDialogTriggered: true,
    });
  }

  handleClickDialogClose() {
    this.setState({
      isDialogOpen: false,
    });
  }

  renderEmployeeTrade() {
    if (this.props.loggedInUserData.eid === this.props.trade.offeredEmployeeId) {
      return (
        <>
          <Paper className="mobile-shift-trade" elevation={1} onClick={this.handleClickDialogOpen.bind(this)}>
            <div>
              <div className="shift-trade-current-user">
                {this.props.trade.tradeFormType}
                {this.props.trade.requestedShiftStart
                  ? " | " +
                    getShiftDate(this.props.trade.requestedShiftStart) +
                    " " +
                    getShiftTime(this.props.trade.requestedShiftStart) +
                    "-" +
                    getShiftTime(this.props.trade.requestedShiftEnd)
                  : ""}
              </div>
              <div>
                to {this.props.trade.requestedEmployeeLastName}, {this.props.trade.requestedEmployeeFirstName} |{" "}
                {getShiftDate(this.props.trade.offeredShiftStart)} {getShiftTime(this.props.trade.offeredShiftStart)}-
                {getShiftTime(this.props.trade.offeredShiftEnd)}
              </div>
              <div>
                {this.props.isAdminPage
                  ? this.props.trade.visibleTradeStatusAdmin
                  : this.props.trade.visibleTradeStatus}{" "}
                | {getShiftDate(this.props.trade.createdAt)} {getShiftTime(this.props.trade.createdAt)}
              </div>
            </div>
          </Paper>
          <TradeDialog
            loggedInUserData={this.props.loggedInUserData}
            eid={this.props.loggedInUserData.eid}
            isAdmin={this.props.loggedInUserData.isAdmin}
            isAdminPage={this.props.isAdminPage}
            trade={this.props.trade}
            isDialogOpen={this.state.isDialogOpen}
            handleClickDialogOpen={this.handleClickDialogOpen.bind(this)}
            handleClickDialogClose={this.handleClickDialogClose.bind(this)}
            isDesktopView={this.props.isDesktopView}
          />
        </>
      );
    } else {
      return (
        <>
          <Paper className="mobile-shift-trade" elevation={1} onClick={this.handleClickDialogOpen.bind(this)}>
            <div>
              <div className="shift-trade-current-user">
                {this.props.trade.tradeFormType} | {getShiftDate(this.props.trade.offeredShiftStart)}{" "}
                {getShiftTime(this.props.trade.offeredShiftStart)}-{getShiftTime(this.props.trade.offeredShiftEnd)}
              </div>
              <div>
                from {this.props.trade.offeredEmployeeLastName}, {this.props.trade.offeredEmployeeFirstName}
                {this.props.trade.requestedShiftStart
                  ? " | " +
                    getShiftDate(this.props.trade.requestedShiftStart) +
                    " " +
                    getShiftTime(this.props.trade.requestedShiftStart) +
                    "-" +
                    getShiftTime(this.props.trade.requestedShiftEnd)
                  : ""}
              </div>
              <div>
                {this.props.isAdminPage
                  ? this.props.trade.visibleTradeStatusAdmin
                  : this.props.trade.visibleTradeStatus}{" "}
                | {getShiftDate(this.props.trade.createdAt)} {getShiftTime(this.props.trade.createdAt)}
              </div>
            </div>
          </Paper>
          <TradeDialog
            loggedInUserData={this.props.loggedInUserData}
            eid={this.props.loggedInUserData.eid}
            isAdmin={this.props.loggedInUserData.isAdmin}
            isAdminPage={this.props.isAdminPage}
            trade={this.props.trade}
            isDialogOpen={this.state.isDialogOpen}
            handleClickDialogOpen={this.handleClickDialogOpen.bind(this)}
            handleClickDialogClose={this.handleClickDialogClose.bind(this)}
            isDesktopView={this.props.isDesktopView}
          />
        </>
      );
    }
  }

  render() {
    return <div data-testid="employee-trade-mobile">{this.renderEmployeeTrade()}</div>;
  }
}

EmployeeTradeMobile.propTypes = {
  loggedInUserData: PropTypes.object.isRequired,
  trade: PropTypes.object.isRequired,
  isAdminPage: PropTypes.bool.isRequired,
  isDesktopView: PropTypes.bool.isRequired,
};

export default EmployeeTradeMobile;
